import cs from 'date-fns/locale/cs';
import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-GB';
import pl from 'date-fns/locale/pl';
import ro from 'date-fns/locale/ro';

type DateFnsLocale = typeof en;

// date-fns locales of the UI languages; anything else formats in English
export const dateFnsLocales: Record<string, DateFnsLocale> = {
  en,
  pl,
  cs,
  de,
  ro,
};

export const dateFnsLocale = (language: string): DateFnsLocale =>
  dateFnsLocales[language] ?? en;
